import Divider from '@shared/components/Divider/Divider';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Pencil } from 'assets/icons/Pencil.svg';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';
import { isWorkspaceAliasEnabled } from 'modules/Workspaces/WorkspacesProvider/utils';

import WorkspaceLogoSetting from './WorkspaceLogoSetting';
import WorkspaceNameSetting from './WorkspaceNameSetting';
import WorkspaceUrlSetting from './WorkspaceUrlSetting';

const GeneralSettingsSection = () => {
  const { t } = useTranslation();
  const { workspacePermissions } = useWorkspacesContext({ requireWorkspaceId: true });

  const hasLogoPermission = workspacePermissions.workspaceLogo;
  const hasNamePermission = workspacePermissions.workspaceName;
  const hasUrlPermission = isWorkspaceAliasEnabled && workspacePermissions.workspaceUrl;

  if (!hasLogoPermission && !hasNamePermission && !hasUrlPermission) return null;

  const hasLogoDivider = hasNamePermission;
  const hasUrlDivider = hasNamePermission || hasLogoPermission;

  return (
    <SettingsCard>
      <div className="w-full h-full p-2">
        <SettingsCard.Header title={t('settings')} icon={Pencil} />
        {hasLogoPermission && (
          <>
            <WorkspaceLogoSetting />
            {hasLogoDivider && <Divider />}
          </>
        )}
        {hasNamePermission && <WorkspaceNameSetting />}
        {hasUrlPermission && (
          <>
            {hasUrlDivider && <Divider />}
            <WorkspaceUrlSetting />
          </>
        )}
      </div>
    </SettingsCard>
  );
};

export default GeneralSettingsSection;
